import Vue from 'vue';
import Router from 'vue-router';
import ProjectAddition from './components/ProjectAddition.vue';
import ProjectEdit from './components/ProjectEdit.vue';
import PoiAddition from './components/PoiAddition.vue';
import PoiEdit from './components/PoiEdit.vue';
import QuizAddition from './components/QuizAddition.vue';
import QuizEdit from './components/QuizEdit.vue';
import SearchProjectToEdit from './components/SearchProjectToEdit.vue';
import SearchProjectToCreatePoi from './components/SearchProjectToCreatePoi.vue';
import SearchPoiToEdit from './components/SearchPoiToEdit.vue';
import SearchPoiToCreateQuiz from './components/SearchPoiToCreateQuiz.vue';
import SearchPoiToEditQuiz from './components/SearchPoiToEditQuiz.vue';
import AdminConsole from './components/AdminConsole.vue';

Vue.use(Router);

export default new Router({
    //base: process.env.NODE_ENV === 'production' ?  '/nextgencms'  : '/',
    routes: [
        {
            path: '/project_addition',
            component: ProjectAddition
        },
        {
            path: '/project_edit',
            component: ProjectEdit
        },
        {
            path: '/poi_addition',
            component: PoiAddition
        },
        {
            path: '/poi_edit',
            component: PoiEdit
        },
        {
            path: '/quiz_addition',
            component: QuizAddition
        },
        {
            path: '/quiz_edit',
            component: QuizEdit
        },
        {
            path: '/search_project_to_edit',
            component: SearchProjectToEdit
        },
        {
            path: '/search_project_to_create_poi',
            component: SearchProjectToCreatePoi
        },
        {
            path: '/search_poi_to_edit',
            component: SearchPoiToEdit
        },
        {
            path: '/search_poi_to_create_quiz',
            component: SearchPoiToCreateQuiz
        },
        {
            path: '/search_poi_to_edit_quiz',
            component: SearchPoiToEditQuiz
        },
        {
            path: '/admin_console',
            component: AdminConsole
        },
      
    ],
    mode: 'history'
});
